export default __webpack_public_path__ + "static/media/partners-hero-background-mobile.6c8d7a7f.png";